import { render, staticRenderFns } from "./LinkWithApisOrders.vue?vue&type=template&id=ba3aa8d6&scoped=true&"
import script from "./LinkWithApisOrders.vue?vue&type=script&lang=js&"
export * from "./LinkWithApisOrders.vue?vue&type=script&lang=js&"
import style0 from "./LinkWithApisOrders.vue?vue&type=style&index=0&id=ba3aa8d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba3aa8d6",
  null
  
)

export default component.exports